export class BuiltinBase {
    constructor() {
        this.types = new Set();
    }
}

//# sourceMappingURL=BuiltinBase.js.map
